import { format, parseISO } from 'date-fns';
import { pt } from 'date-fns/locale';
import { useState, useEffect } from 'react';
import { useGlobal } from '../../../contexts/globalContext';
import { getSessionStorage } from '../../../utils/getSessionStorage';
import Separator from '../../Separator';

import * as S from './styles';

const PackageSideSummary = ({
	total,
	totalApagar,
	cashPrice,
	pointsPrice,
	pointsTotalValue,
	cashTotalValue,
	userPoints,
	minimumPointsToBuy,
	discountPoints,
	discountCash,
}) => {
	const { signed, user } = useGlobal();
	const [coinAlias, setCoinAlias] = useState('Pontos');
	const [shortenCoinAlias, setShortenCoinAlias] = useState('Pts');
	const [packageSelected, setPackageSelected] = useState(null);

	useEffect(() => {
		setCoinAlias(user?.campaign?.campaignConfig?.coinAlias || 'Pontos');
		setShortenCoinAlias(
			user?.campaign?.campaignConfig?.shortenCoinAlias || 'Pts'
		);
	}, [
		user?.campaign?.campaignConfig?.coinAlias,
		user?.campaign?.campaignConfig?.shortenCoinAlias,
	]);

	useEffect(() => {
		const packageData = getSessionStorage('@PackageSelected');
		if (packageData) {
			setPackageSelected(packageData);
		}
	}, []);

	const Header = ({ type, date, ...props }) => {
		return (
			<S.SideHeader {...props}>
				<div>
					<span>{type}</span>
				</div>
				<span className='date-header'>
					{date !== undefined &&
						date !== 'Invalid Date' &&
						format(parseISO(date), 'EEE, dd MMM yyyy', {
							locale: pt,
						})}
				</span>
			</S.SideHeader>
		);
	};

	return (
		<div>
			{packageSelected && (
				<>
					<Header
						className='first'
						type='Check-in'
						date={packageSelected.checkIn}
					/>
					<S.BlankCardOnly>
						<div className='package-details'>
							<span className='package-name'>
								{packageSelected.hotelName}
							</span>
							<span>Quarto: {packageSelected.roomName}</span>
							<span>Total para {packageSelected.nights} noites</span>
						</div>
					</S.BlankCardOnly>
					<Header type='Check-out' date={packageSelected.checkOut} />
				</>
			)}
			<Separator className='solid thin' />

			<S.BlankCardOnly>
				<S.PagamentoLabel>Pagamento</S.PagamentoLabel>
				<Separator className='solid thin' margin={15} />
				<Separator className='solid' margin={15} />
				<S.Total className='wrap'>
					{signed && !user?.guest && !user?.campaign?.disablePointActivity && (
						<div>
							<span className='bold total'>Valor do Saldo</span>
							<span className='bold total'>
								{signed ? shortenCoinAlias : 'R$'} {total}
							</span>
						</div>
					)}
				</S.Total>
				<S.Total>
					<span className='semibold total'>Subtotal em R$</span>
					<span className='semibold total'>
						{new Intl.NumberFormat('pt-BR', {
							minimumFractionDigits: 2,
							maximumFractionDigits: 2,
						}).format(cashTotalValue)}
					</span>
				</S.Total>
				{discountPoints > 0 && (
					<S.Total>
						<span className='bold total'>Desconto aplicado em {coinAlias}</span>
						<span className='bold total'>
							{shortenCoinAlias} {discountPoints}
						</span>
					</S.Total>
				)}
				{discountCash > 0 && (
					<S.Total>
						<span className='bold total'>Desconto aplicado em R$</span>
						<span className='bold total'>
							{discountCash.toLocaleString('pt-BR', {
								style: 'currency',
								currency: 'BRL',
							})}
						</span>
					</S.Total>
				)}
				{user?.campaign?.acceptCashPayment && (
					<S.Total>
						<span className='bold total'>Total em R$</span>
						<span className='bold total'>
							{totalApagar.toLocaleString('pt-BR', {
								style: 'currency',
								currency: 'BRL',
							})}
						</span>
					</S.Total>
				)}
			</S.BlankCardOnly>
		</div>
	);
};

export default PackageSideSummary;
